<template>
  <b-container fluid>
    <b-row>
      <b-col lg="4" md="6" v-for="(list,index) in product" :key="index">
        <iq-card
          :class-name="'iq-card-block iq-card-stretch iq-card-height '+list.bgColor+' rounded'"
        >
          <template v-slot:body>
            <div class="d-flex align-items-center justify-content-between">
              <div
                :class="' icon iq-icon-box rounded iq-'+list.bgColor+' rounded shadow '"
                data-wow-delay="0.2s"
              >
                <i :class="list.iconClass"></i>
              </div>
              <div class="iq-text">
                <h6 class="text-white">{{ list.text }}</h6>
                <h3 class="text-white">{{ list.count() }}</h3>
              </div>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="4">
        <b-card class="iq-mb-3" v-for="(annouce, key) in annoucement" :key="key">
          <template #header>
            <div class="nav-item">
              <span class="bg-primary dots"></span>
              {{ annouce.title }}
            </div>
          </template>
          <b-card-text v-html="annouce.content"/>
        </b-card>
        <b-card class="iq-mb-3" v-show="userInfo.enabled_2fa === 0">
          <template #header>
            <div class="nav-item">
              <span class="bg-primary dots"></span>
              Cập nhật 2FA
            </div>
          </template>
          <b-card-text>
            Nhằm tăng tính tiện dụng và bảo mật cá nhân, chúng tôi cung cấp tính năng bảo mật 2 lớp (2FA), quý khách hãy
            cập nhật để bảo vệ tài khoản của mình tốt hơn
            <hr>
            <two-factor-authentication-modal/>
          </b-card-text>
        </b-card>
      </b-col>
      <b-col lg="8">
        <b-card class="iq-mb-3">
          <template #header>
            <b> Về chúng tôi </b>
          </template>
          <b-card-text>
            <b>123GOM</b> là một phần mềm kế toán tổng hợp, giúp cho người dùng nhanh chóng thống kê được lãi lỗ, từ đó
                          dễ dàng vạch ra được hướng đi, chiến lược cho tương lai. <br/> Phần mềm hoạt động bằng cách tự
                          động lấy dữ liệu và tính toán dựa trên các tài khoản và công thức được người dùng thiết lập
                          sẵn. <br/>
          </b-card-text>
          <b-card-text class="mb-3">
            <b>Những hệ thống đã tích hợp bao gồm</b>
          </b-card-text>
          <b-list-group class="mb-3">
            <b-list-group-item class="px-2 py-1" active>SPORTBOOK</b-list-group-item>
            <b-list-group-item class="px-2 py-1">BONG88</b-list-group-item>
            <b-list-group-item class="px-2 py-1">SBOBET</b-list-group-item>
            <b-list-group-item class="px-2 py-1">3IN1</b-list-group-item>
          </b-list-group>
          <b-list-group class="mb-3">
            <b-list-group-item class="px-2 py-1" active>CASINO</b-list-group-item>
            <b-list-group-item class="px-2 py-1">LASVEGAS</b-list-group-item>
            <b-list-group-item class="px-2 py-1">SGD777</b-list-group-item>
            <b-list-group-item class="px-2 py-1">SA36</b-list-group-item>
            <b-list-group-item class="px-2 py-1">MACAO166</b-list-group-item>
          </b-list-group>
          <b-list-group class="mb-3">
            <b-list-group-item class="px-2 py-1" active>LOTO</b-list-group-item>
            <b-list-group-item class="px-2 py-1">HK1119</b-list-group-item>
            <b-list-group-item class="px-2 py-1">OK368</b-list-group-item>
            <b-list-group-item class="px-2 py-1">VN868</b-list-group-item>
            <b-list-group-item class="px-2 py-1">LD789</b-list-group-item>
            <b-list-group-item class="px-2 py-1">6D9</b-list-group-item>
            <b-list-group-item class="px-2 py-1">SGS889</b-list-group-item>
            <b-list-group-item class="px-2 py-1">NEW789</b-list-group-item>
            <b-list-group-item class="px-2 py-1">LDBONG88</b-list-group-item>
          </b-list-group>
          <b-list-group class="mb-3">
            <b-list-group-item class="px-2 py-1" active>COCKFIGHT</b-list-group-item>
            <b-list-group-item class="px-2 py-1">SV388</b-list-group-item>
            <b-list-group-item class="px-2 py-1">S1288</b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { findash } from '../../config/pluginInit'
import api from '../../store/api'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import TwoFactorAuthenticationModal from '@/components/application/account/TwoFactorAuthenticationModal'

export default {
  name: 'Dashboard1',
  components: { TwoFactorAuthenticationModal },
  mounted () {
    findash.index()

    this.count_customer = this.customers.length
    this.count_accounts = _.filter(this.accounts, (e) => {
      return e.parent_id === '0'
    }).length
    this.count_sub_accounts = this.subAccounts.length
  },
  created () {
    api.annoucement.list(2).then((list) => {
      this.annoucement = _.orderBy(list, (e) => {
        return e.created_at
      })

      let lastAnnoucement = _.last(this.annoucement)
      let currentLastAnnoucement = JSON.parse(localStorage.getItem('lastAnnoucement'))

      // display the popup
      if ((currentLastAnnoucement && lastAnnoucement['content'] !== currentLastAnnoucement['content']) || currentLastAnnoucement === null) {
        localStorage.setItem('lastAnnoucement', JSON.stringify(lastAnnoucement))
        this.$swal.fire({
          title: lastAnnoucement['title'],
          html: lastAnnoucement['content'].replace(/&nbsp;/g, ''),
          showCloseButton: false,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'OK'
        })
      }
    }).catch((e) => {
      console.log(e)
    })

    // custom advertise, that show everyday once
    let nextMerchantPopup = localStorage.getItem('nextMerchantPopup')

    const today = moment(new Date())
    const nextMerchantPopupDate = moment(nextMerchantPopup)

    if (today.isAfter(nextMerchantPopupDate) || nextMerchantPopup === null) {
      this.$swal.fire({
        html: "<a href='https://citybet888.vip/register?ref=3WA5lwi' target='_blank'><img src='./img/banner_01.jpg'/></a>",
        width: '1338px',
        showCancelButton: false,
        focusConfirm: false,
        showCloseButton: true,
        showConfirmButton: false
      }).then((result) => {
        if (result.isDismissed) {
          localStorage.setItem('nextMerchantPopup', moment(new Date()).add(1, 'days'))
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      'userInfo': 'Auth/userInfoState',
      'customers': 'Customer/listState',
      'accounts': 'Account/listState',
      'subAccounts': 'SubAccount/listState'
    })
  },
  watch: {
    customers: function (newVal, oldVal) {
      if (typeof (newVal) === 'object') {
        this.count_customer = newVal.length
      }
    },
    accounts: function (newVal, oldVal) {
      if (typeof (newVal) === 'object') {
        this.count_accounts = _.filter(this.accounts, (e) => {
          return e.parent_id === '0'
        }).length
      }
    },
    subAccounts: function (newVal, oldVal) {
      if (typeof (newVal) === 'object') {
        this.count_sub_accounts = newVal.length
      }
    }
  },
  data () {
    return {
      annoucement: [],
      count_customer: 0,
      count_accounts: 0,
      count_sub_accounts: 0,
      product: [
        {
          title: 'customers',
          count: () => this.count_customer,
          text: 'Khách hàng',
          bgColor: 'bg-primary',
          iconClass: 'las la-users las-large'
        },
        {
          title: 'account',
          count: () => this.count_accounts,
          text: 'Tài khoản',
          bgColor: 'bg-primary',
          iconClass: 'lab la-product-hunt'
        },
        {
          title: 'user',
          count: () => this.count_sub_accounts,
          text: 'Thành viên',
          bgColor: 'bg-primary',
          iconClass: 'las la-user-tie las-large'
        }
      ]
    }
  }
}
</script>
<style>
.iq-card-body {
  flex : unset;
}
.swal2-close:focus{
  box-shadow: none;
}
</style>
